/* eslint-disable jsx-a11y/alt-text */
import { useAuth0 } from "@auth0/auth0-react";
import { Box, TableContainer, Popover } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import ArchiveIcon from "@mui/icons-material/Archive";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PreSchoolService from "Lib/API/PreSchool";
import Action from "components/ActionPopOver";
import { CheckBox } from "components/CheckBox/CheckBox";
import AlertDialog from "components/Dialog";
import MyButton from "components/MyButton";
import SearchComp from "components/Searchcomponent";
import SendLetter from "components/SendLetter/SendLetter";
import SuccessModal from "components/SuccessModal/SuccessModal";
import RightDrawer from "components/drawer";
import Loader from "components/loader/Loader";
import ProgressBar from "components/progressBar/progressbar";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { setFormName } from "services/api/forms";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  displayProductsHandler,
  getFormDataHandler,
} from "utils/formDataHelper";
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import { setOpenRecipients, setSelectedDeceased } from "../commonSlice";
import Recipients from "../deceasedLetter/Recipients";
import FormDrawer from "../formComponent/FormDrawer";
import "../index.scss";
import FilterIcon from "assets/icons/icon.png";
import { PopoverActionCol, PopoverBox } from "./Theme";
import { PopoverButton, PopoverWrapper } from "./Theme";
import { fontConfig } from "theme/fontConfig";

const TableCellHead = withStyles((theme) => ({
  root: {
    height: "39px",
    padding: "0px 20px",
    borderBottom: "none",
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: "65px",
    padding: "0px 20px",
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
    fontSize: "14px",
  },
}))(TableCell);

const TableColumnFilter = ({
  options = [],
  onChange,
  value = [],
  isNotAllNeed = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleFilterChange = (val) => {
    onChange(val, options);
  };

  const isAllSelected =
    !isNotAllNeed &&
    options.length > 0 &&
    value.length === options.length &&
    options.every((opt) => value.includes(opt.value));

  return (
    <div>
      <PopoverButton onClick={handleClick} style={{ position: "relative" }}>
        <img src={FilterIcon} alt="filter" />
        {!isAllSelected && value?.length > 0 && (
          <Box
            sx={{
              width: 6,
              height: 6,
              backgroundColor: "#ff3668",
              borderRadius: "50%",
              position: "absolute",
              top: -3,
              right: -4,
              zIndex: 100,
            }}
          ></Box>
        )}
      </PopoverButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{
          style: {
            width: 330,
            maxWidth: "100%",
          },
        }}
      >
        <PopoverWrapper>
          <>
            {!isNotAllNeed && (
              <PopoverActionCol onClick={() => handleFilterChange("all")}>
                <PopoverBox checked={isAllSelected} />
                <span>All</span>
              </PopoverActionCol>
            )}

            {options?.map((opt) => (
              <PopoverActionCol
                key={opt.value}
                onClick={() => handleFilterChange(opt.value)}
              >
                <PopoverBox checked={value.includes(opt.value)} />
                <span>{opt.label}</span>
              </PopoverActionCol>
            ))}
          </>
        </PopoverWrapper>
      </Popover>
    </div>
  );
};

const MembersForms = ({
  setOpenDialog,
  duplicate,
  setError,
  newClassName,
  setData,
  setDisabled,
  handleInputChange,
  searchValue,
  toggle,
  tableContainerRef,
  activeFormPage,
  setActiveFormPage,
}) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [selectionModel, setSelectionModel] = useState([]);
  const history = useHistory();
  const [count, setCount] = useState();
  const dispatch = useDispatch();
  const [deleteFormId, setDeleteFormId] = useState(null);
  const [duplicateFormId, setDuplicateFormId] = useState(null);
  const [archiveFormId, setArchiveFormId] = useState([]);
  const [archiveStatus, setArchiveStatus] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [check, setCheck] = useState([]);
  const [exportAllTable, setExportAllTable] = useState(false);
  const [archived, setArchived] = useState(["no"]);
  const styleButtons = {
    color: "#454758",
    fontSize: "14px",
    fontWeight: "400",
  };
  const [csvData, setExportData] = useState([]);
  const [participantExportData, setParticipantExportData] = useState([]);
  const [enableExportingParticipants, setEnableExportingParticipants] =
    useState(false);
  const [exportType, setExportType] = useState("");
  const [checkAll, setCheckAll] = useState(false);
  const [openLetterModal, setOpenLetterModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [sendLetterLoading, setSendLetterLoading] = useState(false);
  const [exportAllClassesParticipants, setExportAllClassesParticipants] =
    useState(false);
  const [exportAllLoading, setExportAllLoading] = useState(false);
  const [
    exportAllClassesParticipantsLoading,
    setExportAllClassesParticipantsLoading,
  ] = useState(false);

  const openRecipients = useSelector(
    (state) => state.CommonStates.openRecipients
  );

  const organization = localStorage.getItem("organization")
    ? JSON.parse(localStorage.getItem("organization"))
    : null;
  const deleteForm = async (id) => {
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      await PreSchoolService.deleteMemberForm(token, id);
      toastr.success("Success", "Form Deleted Successfully!");
      setRefresh(!refresh);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      setDeleteFormId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
      setIsDrawerOpen(false);
    }
  };
  const archiveForm = async () => {
    const data = {
      ids: archiveFormId,
      status: archiveStatus,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      await PreSchoolService.archiveMemberForm(token, data);
      toastr.success(
        "Success",
        `Form ${archiveStatus ? "Archived" : "Un-Archived"} Successfully!`
      );
      setRefresh(!refresh);
      setCheck([]);
      setCheckAll(false);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      setArchiveFormId([]);
      setConfirmDialog(false);
      setConfirmLoading(false);
      setIsDrawerOpen(false);
    }
  };

  const duplicateForm = async (duplicateFormId) => {
    const payload = {
      formId: duplicateFormId,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      await PreSchoolService.duplicateMemberForm(token, payload);
      toastr.success("Success", "Form Duplicated Successfully!");
      setRefresh(!refresh);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      setDuplicateFormId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };

  useEffect(() => {
    if (selectionModel.length > 1) {
      setError("You Can Duplicate 1 Form only!");
      setDisabled(true);
    } else if (selectionModel.length === 1) {
      const data = {
        selectedClassId: selectionModel[0],
        newClassName: newClassName,
      };
      setOpenDialog(true);
      setData(data);
    }
  }, [duplicate, newClassName]);

  useEffect(() => {
    if (selectionModel.length > 1) setDisabled(true);
    else setDisabled(false);
  }, [selectionModel]);

  const onCheckboxAllChange = (e) => {
    setCheckAll(e.target.checked);
    if (!e.target.checked) {
      setCheck([]);
    }
  };

  const enableLoading = (value) => setLoading(value);

  async function getFormList(searchKey) {
    enableLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.getMemberForms(
        token,
        activeFormPage + 1,
        30,
        {
          ...(searchKey && { search: searchKey }),
          filter: { archived: archived?.length === 2 ? "all" : archived[0] },
        }
      );

      setList(result?.payload?.data);
      setCount(result?.payload?.pagination?.count);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      enableLoading(false);
    }
  }

  useEffect(() => {
    getFormList(searchValue);
  }, [activeFormPage, refresh, searchValue, archived]);

  const onCheckboxChange = (e, row) => {
    const { checked } = e.target;
    if (checkAll) return;
    if (!checked) {
      setCheckAll(false);
      setCheck((prev) => {
        const checkClone = prev.filter((item) => item._id !== row._id);
        return [...checkClone];
      });
      return;
    }
    setCheck((prev) => [...prev, row]);
  };
  const columns_for_header = [
    {
      id: "formName",
      displayName: "Form Name",
      headerName: "Form Name",
      field: "formName",
      flex: 1,
    },
    {
      id: "date",
      displayName: "Date",
      headerName: "Date",
      field: "date",
      flex: 1,
    },
    {
      id: "formStartDate",
      displayName: "Form Start Date",
      headerName: "Form Start Date",
      field: "formStartDate",
      flex: 1,
    },
    {
      id: "formEndDate",
      displayName: "Form End Date",
      headerName: "Form End Date",
      field: "formEndDate",
      flex: 1,
    },
    {
      id: "total",
      displayName: "Response",
      headerName: "Response",
      field: "total",
      flex: 1,
    },
    {
      id: "total_cost",
      displayName: "Total Paid",
      headerName: "Total Paid",
      field: "total_cost",
      flex: 1,
    },
  ];
  const componentRef = useRef();

  const getExportFileName = () => {
    if (exportAllClassesParticipants) {
      return "Participants.xlsx";
    } else if (exportAllTable) {
      return `${drawerData?.formName}.xlsx`;
    } else if (check?.length === 1) {
      return `${check[0]?.formName}.xlsx`;
    } else {
      return "Forms.xlsx";
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: getExportFileName(),
  });
  useEffect(() => {
    if (exportType == "print") {
      handlePrint();
    }
    setExportType("");
  }, [exportType]);
  const compareDate = (date) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const date1 = new Date(date);
    if (date1.toDateString() === today.toDateString()) {
      return <span style={{ color: "#2555EF" }}>Today</span>;
    } else if (date1.toDateString() === tomorrow.toDateString()) {
      return <span style={{ color: "#2555EF" }}>Tomorrow</span>;
    } else {
      return formatDate({ date: date, formatType: "defaultWithUTC" });
    }
  };
  const handleArchiveButton = () => {
    const dataList = checkAll ? csvData : check;
    const ides = dataList?.map((item) => {
      return item._id;
    });
    setArchiveFormId(ides);
    setArchiveStatus(true);
    setConfirmDialog(true);
  };

  const getExportParticipantsData = async (value) => {
    if (exportAllClassesParticipants) {
      setExportAllClassesParticipantsLoading(true);
    } else {
      setExportAllLoading(true);
    }
    const token = await getAccessTokenSilently();
    const body = {
      formId: !exportAllClassesParticipants ? drawerData?._id : undefined,
      formsIds: exportAllClassesParticipants
        ? checkAll
          ? []
          : check.map((item) => item._id)
        : [],
      participantsIds: [],
    };
    PreSchoolService.exportFormParticipant(token, body)
      .then((res) => {
        setParticipantExportData(res?.payload?.data);
        setEnableExportingParticipants(true);
      })
      .catch((err) => {
        setEnableExportingParticipants(false);
        toastr.error("Error", err?.data?.message || "Something went wrong!");
      })
      .finally(() => {
        if (exportAllClassesParticipants) {
          setExportAllClassesParticipantsLoading(false);
        } else {
          setExportAllLoading(false);
        }
      });
  };

  const excelSheet = () => {
    const arr = [];
    const dataExport = checkAll ? csvData : check;
    if (exportAllTable || exportAllClassesParticipants) {
      participantExportData.map((item) => {
        const data = {
          ["#"]: item?.groupId?.toString(),
          ...(exportAllClassesParticipants
            ? {
                ["Form Name"]: item?.onlineForm?.formName,
              }
            : {}),
          ["First Name"]: item?.firstName,
          ["Last Name"]: item?.lastName,
          ["Email"]: item?.email,
          ["Submission"]: formatDate({
            date: item?.createAt,
            formatType: "defaultWithUTC",
          }),
          ["Payment Status"]: item?.registrationStatus,
          ["Total paid"]: numberFormat({
            number: +item?.payment?.register?.totalPaid,
            decimal: 2,
            style: "currency",
          }),
          ...getFormDataHandler(
            item?.onlineForm?.form?.task_data,
            item?.formData
          ),
          ...displayProductsHandler(item?.products),
        };
        arr.push(data);
      });
    } else if (isDrawerOpen && !exportAllTable) {
      const data = {
        ["Form Name"]: drawerData?.formName,
        ["Date"]: formatDate({
          date: drawerData?.createdAt,
          formatType: "defaultWithUTC",
        }),
        ["Enrollment Start Date"]: formatDate({
          date: drawerData?.formStartDate,
          formatType: "defaultWithUTC",
        }),
        ["Enrollment End Date"]: drawerData?.alwaysAvailable
          ? "Always available"
          : formatDate({
              date: drawerData?.formEndDate,
              formatType: "defaultWithUTC",
            }),
        ["Response"]: drawerData?.participantsDetails?.total,
        ["Total Paid"]: numberFormat({
          number: drawerData?.formPricing?.total_cost,
          decimal: 2,
          style: "currency",
        }),
      };
      arr.push(data);
    } else if (checkAll || check?.length > 0) {
      dataExport.map((item) => {
        const data = {
          ["Form Name"]: item?.formName,
          ["Date"]: formatDate({
            date: item?.createdAt,
            formatType: "defaultWithUTC",
          }),
          ["Enrollment Start Date"]: formatDate({
            date: item?.formStartDate,
            formatType: "defaultWithUTC",
          }),
          ["Enrollment End Date"]: item?.alwaysAvailable
            ? "Always available"
            : formatDate({
                date: item?.formEndDate,
                formatType: "defaultWithUTC",
              }),
          ["Response"]: item?.participantsDetails?.total,
          ["Total Paid"]: numberFormat({
            number: item?.formPricing?.total_cost,
            decimal: 2,
            style: "currency",
          }),
        };
        arr.push(data);
      });
    }
    return arr;
  };
  const generateExcel = () => {
    let res = excelSheet();
    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(res));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, getExportFileName());
    setExportAllTable(false);
    setExportAllClassesParticipants(false);
  };

  const downloadExcel = () => {
    generateExcel();
  };
  useEffect(() => {
    if (exportAllClassesParticipantsLoading || exportAllLoading) return;
    if (!exportAllTable && !exportAllClassesParticipants) return;
    if (exportAllTable && drawerData?.participantsDetails?.total === 0) {
      toastr.info("validation", "No participants found");
      return;
    }
    getExportParticipantsData();
  }, [exportAllTable, exportAllClassesParticipants]);
  useEffect(() => {
    if (!enableExportingParticipants) return;
    downloadExcel();
    setEnableExportingParticipants(false);
  }, [enableExportingParticipants]);

  let customCsvData = [];
  let myData =
    csvData?.length !== 0 &&
    csvData?.map((item) => {
      // return item?.map((li) => {
      const data = {
        formName: item?.formName,
        date: formatDate({
          date: item?.createdAt,
          formatType: "defaultWithUTC",
        }),
        formStartDate: formatDate({
          date: item?.formStartDate,
          formatType: "defaultWithUTC",
        }),
        alwaysAvailable: item?.alwaysAvailable,
        formEndDate: formatDate({
          date: item?.formEndDate,
          formatType: "defaultWithUTC",
        }),
        allowNonMembers: item?.allowNonMembers,
        total: item?.participantsDetails?.total,
        total_cost: numberFormat({
          number: item?.formPricing?.total_cost,
          decimal: 2,
          style: "currency",
        }),
      };
      customCsvData.push(data);
      // });
    });

  // const getExportData = async (value) => {
  //   const token = await getAccessTokenSilently();
  //   const ides = checkAll
  //     ? []
  //     : check.map((item) => {
  //         return item._id;
  //       });
  //   const body = { formsIds: ides };
  //   PreSchoolService.exportMemberForm(token, body)
  //     .then((res) => {
  //       setExportData(res?.payload?.data);
  //       setExportType(value);
  //     })
  //     .catch((err) => {});
  // };
  // useEffect(() => {
  //   getExportData();
  // }, [checkAll]);

  const calculateParticipantsPercentage = (row) => {
    const totalParticipants = row?.participantsDetails?.total;
    const maximumParticipants = row?.totalAccounts;
    const percentage = (totalParticipants / maximumParticipants) * 100;
    return percentage >= 0 ? Math.round(percentage) : 0;
  };

  const handleSendLetter = async (templateData) => {
    setSendLetterLoading(true);
    const token = await getAccessTokenSilently();
    const bodyData = {
      formsIds: checkAll ? [] : check.map((item) => item._id),
      all: checkAll ? true : false,
      ...templateData,
    };

    PreSchoolService.sendFormParticipantLetter(token, bodyData)
      .then((response) => {
        setOpenSuccessModal(true);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong!");
      })
      .finally(() => {
        setSendLetterLoading(false);
        setOpenLetterModal(false);
      });
  };

  const calculateTotalParticipants = () => {
    let total = 0;
    check.forEach((item) => {
      total += item?.participantsDetails?.total;
    });
    return total;
  };

  const handleArrayFilterChange = (value, options = []) => {
    const allValues = options?.map((opt) => opt.value);
    let updatedArray;

    if (value === "all") {
      const isAllSelected = allValues.every((val) => archived?.includes(val));
      updatedArray = isAllSelected ? [] : [...allValues];
    } else {
      const isSelected = archived?.includes(value);
      if (isSelected) {
        updatedArray = archived?.filter((item) => item !== value);
      } else {
        updatedArray = [...archived, value];
      }
    }

    setArchived(updatedArray);
  };

  return (
    <div className="w-100 school_class_list">
      <div className={"family-table-container"}>
        <div className="current-class-table-container">
          <div className="header mt-5">
            <div
              style={{
                display: "flex",
                padding: "20px 0px 10px 2px",
                alignItems: "center",
                marginBottom: "18px",
              }}
              className="header__options"
            >
              <span className="finance-filter-serach-bar ml-5">
                <SearchComp
                  value={searchValue}
                  setSearchText={handleInputChange}
                  placeholder="Search"
                  style={{ width: "20.5rem", backgroundColor: "#fff" }}
                />
              </span>
            </div>
            {(checkAll || check?.length > 0) && (
              <div className="new-class d-flex align-items-center">
                <MyButton
                  type="secondary"
                  content={
                    <div className="">
                      <ArchiveIcon style={{ height: "20px" }} />
                      <a style={styleButtons}>Archive</a>
                    </div>
                  }
                  style={{
                    background: "#F4F6F9",
                    color: "#2555EF",
                    border: "none",
                    marginRight: "1rem",
                  }}
                  onClick={handleArchiveButton}
                />
              </div>
            )}
          </div>
          <div
            style={{ paddingLeft: "17px", paddingRight: "17px" }}
            ref={tableContainerRef}
          >
            <TableContainer className="scroll-table">
              <Table aria-label="collapsible table">
                <TableHead className="charges-table sticky-table-header">
                  <TableRow>
                    <TableCellHead className="main-width-class">
                      <CheckBox
                        onChange={(e) => {
                          if (!list?.length) return;
                          onCheckboxAllChange(e);
                        }}
                        text={""}
                        style={{ paddingTop: 8 }}
                        checked={checkAll}
                        isDisabled={!list?.length}
                      />
                    </TableCellHead>

                    <TableCellHead className="class__header__cell className_head">
                      <div>FORM NAME</div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell year__head"
                    >
                      <div>DATE</div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell registration__head"
                    >
                      <div>ENROLLMENT</div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell participants__head"
                    >
                      <div>RESPONSE</div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell total__cost"
                    >
                      <div>TOTAL PAID</div>
                    </TableCellHead>
                    <TableCellHead align="left">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <div style={{ marginRight: 7 }}>ARCHIVED</div>
                        <TableColumnFilter
                          options={[
                            { value: "yes", label: "Yes" },
                            { value: "no", label: "No" },
                          ]}
                          onChange={(val) =>
                            handleArrayFilterChange(val, [
                              { value: "yes", label: "Yes" },
                              { value: "no", label: "No" },
                            ])
                          }
                          value={archived}
                          isNotAllNeed={false}
                        />
                      </div>
                    </TableCellHead>

                    <TableCellHead
                      align="left"
                      className="class__header__cell sticky-header-column"
                    />
                  </TableRow>
                </TableHead>
                <TableBody
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <div
                          className="user__loader"
                          style={{ height: "320px" }}
                        >
                          <Loader />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : list?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <h6 style={{ height: "320px", marginTop: "100px" }}>
                          No Forms Found
                        </h6>
                      </TableCell>
                    </TableRow>
                  ) : (
                    list?.map((row, i) => (
                      <React.Fragment>
                        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                          <TableCellBody
                            className="main-width-class"
                            align="left"
                          >
                            <CheckBox
                              onChange={(e) => onCheckboxChange(e, row)}
                              checked={
                                checkAll
                                  ? true
                                  : check?.some((obj) => obj?._id === row?._id)
                              }
                              text={""}
                              isDisabled={checkAll}
                            />
                          </TableCellBody>
                          <TableCellBody
                            className="status-head main-width-class"
                            component="th"
                            scope="row"
                            onClick={() => {
                              dispatch(setFormName(row?.formName));
                              history.push(`/membership/details/${row?._id}`);
                            }}
                          >
                            <div className="transaction-status">
                              <div style={{ width: 22 }}></div>
                              <div className="pl-0">
                                <div className="school-table-class-name">
                                  {row?.formName}
                                </div>
                              </div>
                            </div>
                          </TableCellBody>
                          <TableCellBody
                            className="main-width-class"
                            align="left"
                          >
                            <div className="table-row">
                              <p className="school-table-year">
                                {formatDate({
                                  date: row?.createdAt,
                                  formatType: "defaultWithUTC",
                                })}
                              </p>
                            </div>
                          </TableCellBody>
                          <TableCellBody
                            className="account-header main-width-class"
                            align="left"
                          >
                            <div className="school-table-registration text-nowrap">
                              {compareDate(row?.formStartDate)} -{" "}
                              {row?.alwaysAvailable
                                ? "Always available"
                                : compareDate(row?.formEndDate)}
                            </div>
                          </TableCellBody>

                          <TableCellBody
                            className="ledger-head main-width-class"
                            align="left"
                          >
                            <ProgressBar
                              bgcolor={
                                row?.participantsDetails?.total > 100
                                  ? "#FA3372"
                                  : "#2555EF"
                              }
                              progress={calculateParticipantsPercentage(row)}
                              height={6}
                              id={row?._id}
                              class_name={row?.formName}
                              value={row?.participantsDetails?.total}
                              maxValue={row?.totalAccounts}
                              // infinite={row?.formDetails?.infiniteCapacity}
                            />
                          </TableCellBody>
                          <TableCellBody
                            className="transaction-head main-width-class"
                            align="left"
                          >
                            {numberFormat({
                              number: +row?.totalPaid,
                              decimal: 2,
                              style: "currency",
                            })}
                          </TableCellBody>
                          <TableCellBody
                            className="transaction-head main-width-class"
                            align="left"
                          >
                            {row?.archived ? (
                              <CheckCircleIcon color="primary" />
                            ) : (
                              <CancelIcon color="primary" />
                            )}
                          </TableCellBody>
                          <TableCellBody
                            className="exp-action-head main-width-class sticky-body-column"
                            align="right"
                          >
                            <div
                              style={{ cursor: "pointer", paddingleft: "0px" }}
                            >
                              <Action
                                action="form"
                                style={{ width: "16px" }}
                                onEditClick={() =>
                                  history.push(
                                    `/edit-membership-form/${row?._id}`
                                  )
                                }
                                onDuplicateClick={() => {
                                  setDuplicateFormId(row?._id);
                                  setConfirmDialog(true);
                                }}
                                onArchiveClick={
                                  !row?.archived
                                    ? () => {
                                        setArchiveFormId([row?._id]);
                                        setArchiveStatus(true);
                                        setConfirmDialog(true);
                                      }
                                    : undefined
                                }
                                onActiveClick={
                                  row?.archived
                                    ? () => {
                                        setArchiveFormId([row?._id]);
                                        setArchiveStatus(false);
                                        setConfirmDialog(true);
                                      }
                                    : undefined
                                }
                                onClassDeleteClick={() => {
                                  setDeleteFormId(row?._id);
                                  setConfirmDialog(true);
                                }}
                                sentInvitation={
                                  !row?.archived
                                    ? () =>
                                        history.push(
                                          `/renewal-form/${row?._id}`
                                        )
                                    : undefined
                                }
                              />
                            </div>
                          </TableCellBody>
                        </TableRow>
                      </React.Fragment>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div className="pagination-custom mt-9">
            <Pagination
              count={Math.ceil(count / 30)}
              color="primary"
              variant="outlined"
              page={activeFormPage + 1}
              onChange={(form, value) => {
                setActiveFormPage(value - 1);
              }}
            />
          </div>
        </div>
        <div className="d-none">
          <div id="componentRef" ref={componentRef}>
            <table style={{ padding: 10, margin: 10 }}>
              <thead>
                {columns_for_header?.map((column, index) => (
                  <th
                    style={{ border: "1px solid", textAlign: "center" }}
                    key={index}
                  >
                    {column?.headerName}
                  </th>
                ))}
              </thead>
              <tbody>
                {customCsvData?.map((item, index) => {
                  const d = {
                    ["Form Name"]: item?.formName,
                    ["Date"]: item?.date,
                    ["Enrollment Start Date"]: item?.formStartDate,
                    ["Enrollment End Date"]: item?.alwaysAvailable
                      ? "Always available"
                      : item?.formEndDate,
                    ["Response"]: item?.total,
                    ["Total Paid"]: item?.total_cost,
                  };
                  return (
                    <tr key={index}>
                      {Object?.values(d)?.map((objectValue, index) => (
                        <td
                          style={{
                            border: "1px solid",
                            padding: 5,
                          }}
                          key={index}
                        >
                          {objectValue}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <AlertDialog
          open={confirmDialog}
          onDecline={() => {
            setDeleteFormId(null);
            setArchiveFormId([]);
            setDuplicateFormId(null);
            setConfirmDialog(false);
          }}
          onAccept={() => {
            if (deleteFormId) {
              deleteForm(deleteFormId);
            }
            if (archiveFormId.length > 0) {
              archiveForm(archiveFormId);
            }
            if (duplicateFormId) {
              duplicateForm(duplicateFormId);
            }
          }}
          title={"Are you sure?"}
          description={` Do you want to ${
            deleteFormId
              ? "delete"
              : duplicateFormId
              ? "duplicate"
              : archiveStatus
              ? "archive"
              : "active"
          } this form?`}
          disabled={confirmLoading}
        />
        <RightDrawer
          open={isDrawerOpen}
          onClose={() => {
            setIsDrawerOpen(false);
          }}
        >
          <FormDrawer
            drawerData={drawerData}
            setIsDrawerOpen={setIsDrawerOpen}
            setConfirmDialog={setConfirmDialog}
            setArchiveStatus={setArchiveStatus}
            setDeleteClassId={setDeleteFormId}
            setArchiveClassId={setArchiveFormId}
            toggle={toggle}
            onExport={downloadExcel}
            setExportAllTable={setExportAllTable}
            exportAllTable={exportAllTable}
          />
        </RightDrawer>

        <Dialog
          open={openLetterModal}
          onClose={() => {
            setOpenLetterModal(false);
          }}
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <SendLetter
            closeModal={() => {
              setOpenLetterModal(false);
            }}
            isMultiple={true}
            handleSendLetter={handleSendLetter}
            sendLetterLoading={sendLetterLoading}
            type="form"
          />
        </Dialog>
        <Dialog
          open={openRecipients}
          onClose={() => {
            dispatch(setOpenRecipients(false));
            dispatch(setSelectedDeceased([]));
            setCheck([]);
          }}
          PaperProps={{
            style: {
              width: "574px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
        >
          <Recipients />
        </Dialog>
        <Dialog
          open={openSuccessModal}
          onClose={() => {
            setOpenSuccessModal(false);
          }}
          PaperProps={{
            style: {
              width: "800px",
              height: "400px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
        >
          <SuccessModal
            title="Successfully Sent"
            description={`The total number of recipients is ${calculateTotalParticipants()}`}
            btnText="Done"
            btnAction={() => {
              setOpenSuccessModal(false);
            }}
            closeModal={() => {
              setOpenSuccessModal(false);
            }}
          />
        </Dialog>
      </div>
    </div>
  );
};

export default MembersForms;
